import { Component, Input, OnInit } from '@angular/core';
import { ApiServiceService } from 'src/app/Services/api-service.service';

@Component({
  selector: 'app-culture-data-integration',
  templateUrl: './culture-data-integration.component.html',
  styleUrls: ['./culture-data-integration.component.css']
})
export class CultureDataIntegrationComponent implements OnInit {
  @Input() userAsin;
  @Input() userNIN;
  @Input() userPlate;

  page: number = 0;
  num: number = 1;
  currentPage: number = 1;
  count: number = 0;
  pageSize: number = 5;
  totalPages: number = 0;
  resultsEmpty: boolean;

  pageSizeOptions: number[] = [5, 10, 20, 50, 100];

  constructor(
    private apiService: ApiServiceService,
  ) {};


  ngOnInit(): void {
    this.fetchInfo()
  }

  data: any = null;
  error: boolean = false;
  fetchInfo() {
    let query = `/data/center/culture/record/by/asin?limit=${this.pageSize}&page=${this.currentPage - 1}`;
    if (this.userAsin) query += `&asin=${this.userAsin}`;
    if (this.userNIN) query += `&nin=${this.userNIN}`;
    if (this.userPlate) query += `&plate=${this.userPlate}`;
  
    this.data = null;
    this.resultsEmpty = false;
    this.error = false;

    this.apiService.get(query).subscribe({
      next: (res: any) => {
        const data = res?.data;
        this.data = data?.records || [];
        this.count = data?.total || 0;
        this.totalPages = data?.total_pages || 0;
        this.resultsEmpty = data?.total == 0 ;
        
      },
      error: (err) => {
        console.error('Error fetching info:', err);

        this.error = true;
      },
    });
  }

  onPageSizeChange() {
    this.currentPage = 1; // reset to first page
    this.fetchInfo();
  }

  // Optional: reset pagination if user changes filters
  resetPagination() {
    this.currentPage = 1;
    this.fetchInfo();
  }
}




